import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from 'primeng/inputswitch';
import { InputSwitchModule } from 'primeng/inputswitch';
import * as i3 from '@angular/forms';
import { FormsModule } from '@angular/forms';

class SwitchComponent {
    checked;
    checkedChange = new EventEmitter();
    text;
    constructor() { }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SwitchComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: SwitchComponent, selector: "a-switch[checked]", inputs: { checked: "checked", text: "text" }, outputs: { checkedChange: "checkedChange" }, ngImport: i0, template: `
		<div class="flex">
			<p-inputSwitch
				[(ngModel)]="checked"
				(ngModelChange)="checkedChange.emit($event)"
				class="{{ text ? 'mr-1' : '' }}">
			</p-inputSwitch>
			<label *ngIf="text">{{ text }}</label>
		</div>
	`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.InputSwitch, selector: "p-inputSwitch", inputs: ["style", "styleClass", "tabindex", "inputId", "name", "disabled", "readonly", "trueValue", "falseValue", "ariaLabel", "ariaLabelledBy"], outputs: ["onChange"] }, { kind: "directive", type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SwitchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'a-switch[checked]', template: `
		<div class="flex">
			<p-inputSwitch
				[(ngModel)]="checked"
				(ngModelChange)="checkedChange.emit($event)"
				class="{{ text ? 'mr-1' : '' }}">
			</p-inputSwitch>
			<label *ngIf="text">{{ text }}</label>
		</div>
	`, changeDetection: ChangeDetectionStrategy.OnPush }]
        }], ctorParameters: function () { return []; }, propDecorators: { checked: [{
                type: Input
            }], checkedChange: [{
                type: Output
            }], text: [{
                type: Input
            }] } });
class SwitchModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SwitchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: SwitchModule, declarations: [SwitchComponent], imports: [CommonModule, InputSwitchModule, FormsModule], exports: [SwitchComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SwitchModule, imports: [CommonModule, InputSwitchModule, FormsModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SwitchModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SwitchComponent],
                    imports: [CommonModule, InputSwitchModule, FormsModule],
                    exports: [SwitchComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SwitchComponent, SwitchModule };
